import { render } from "./licenseService.vue?vue&type=template&id=2163f7fe"
import script from "./licenseService.vue?vue&type=script&lang=js"
export * from "./licenseService.vue?vue&type=script&lang=js"

import "./licenseService.vue?vue&type=style&index=0&id=2163f7fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__